import { api } from "./api"

export const GET_ALL_TRIPS = async ({ datetime }) => {
    const {data} = await api.get(`/trips/all`, { params: { datetime } })
    return data;
}

export const CANCEL_TRIP = async (travelId) => {
    const {data} = await api.patch(`/trips/${travelId}/cancel`)
    return data;
}

export const START_TRIP = async (travelId) => {
    const {data} = await api.patch(`/trips/${travelId}/start`)
    return data;
}

export const FINISH_TRIP = async (travelId) => {
    const {data} = await api.patch(`/trips/${travelId}/finish`)
    return data;
}

